import { styled } from "@mui/system";
import { Typography } from "@mui/material";
import { TEXT_ELLIPSIS } from "../../../../Shared/styles";

export const ReasonListItemText = styled(Typography)({
    ...TEXT_ELLIPSIS,
    paddingRight: "42px",
});
